import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves option types
 * @param {object} _this: context variables
 * @param {string} headerFld: headers to include
 * @param {boolean} includeHeaders: if headers should be included
 */
export function getOptionTypesData(
  _this,
  headerFld = "headersHedge1",
  includeHeaders = true,
) {
  gatewayService.catalogs
    .optionTypes({ format: "json" })
    .then((data) => {
      Object.assign(_this, {
        optionTypes: data,
      });
      let txt = "One of the following: ";
      _this.optionTypes.forEach((d, i) =>
        i < _this.optionTypes.length - 1
          ? (txt += d.name + ", ")
          : (txt += d.name + "."),
      );
      if (includeHeaders) {
        var index = _this[headerFld]
          .map(function(d) {
            return d.text;
          })
          .indexOf("Derivative Type");
        if (index > -1) {
          _this[headerFld][index].explain = txt;
        } else {
          console.error("Could not load optionTypes to headersHedge1");
        }
      }
    })
    .catch(function(error) {
      console.error(error);
    });
}
